import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ProjectTracker } from './components/ProjectTracker'

export const TechRoadmapApp: React.FC = () => {
  return (
    <div className="tech-roadmap-app" style={{ height: '100%', width: '100%' }}>
      <Routes>
        <Route path="/" element={<ProjectTracker />} />
      </Routes>
    </div>
  )
}

export default TechRoadmapApp